export default function (totalCharge, quantity, card) {
  gtag("event", "conversion", {
    send_to: "AW-16733286784/wSUECIuv9OIZEIDjhqs-",
    value: totalCharge,
  });

  gtag("event", "purchase", {
    allow_custom_scripts: true,
    value: totalCharge,
    send_to: "DC-14879299/purchase/lakfa00+transactions",
  });

  ttq.track("Fan Rally - Ticket Purchase", {
    value: totalCharge,
    currency: "USD",
  });

  fbq("track", "Fan Rally Ticket Purchase", {
    currency: "USD",
    value: totalCharge,
  });

  ttq.track("CompletePayment");
}
